export function getNextExercise(exercises, trials) {
  if (!trials) {
    throw new Error("getNextExercise must be called with array of trials");
  }
  if (!exercises) {
    throw new Error("getNextExercise must be called with array of exercises");
  }

  let trialsByExercise = groupTrialsByExercise(trials);
  let sortedExercises = exercises.sort((a, b) => {
    let trialsCount = ex => (trialsByExercise[ex.id] || []).length;
    if (trialsCount(a) === trialsCount(b)) {
      return a.index - b.index;
    }
    return trialsCount(a) - trialsCount(b);
  });

  return {
    exercise: sortedExercises[0],
  }

  function groupTrialsByExercise(sortedTrials) {
    return sortedTrials.reduce((trialsByExercise, trial) => {
      const { exerciseId } = trial;
      (trialsByExercise[exerciseId] = trialsByExercise[exerciseId] || []).push(
        trial
      );
      return trialsByExercise;
    }, {});
  }
}
